// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer-module__wrapper___KqdVZ {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 98px;
}

.Footer-module__content___BgcQK {
  display: flex;
  width: 1238px;
  justify-content: space-between;
  align-items: center;
}

.Footer-module__linksBox___sLm2l {
  display: flex;
  align-items: center;
  gap: 30px;
}

.Footer-module__image___LY_3u {
  width: 104px;
  height: 104px;
}

.Footer-module__image___LY_3u img {
  width: 100%;
}

.Footer-module__links___CApOz {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.Footer-module__icon___T6Dcd {
  width: 24px;
  height: 24px;
}

.Footer-module__author___Bzdox {
  display: flex;
  width: 1238px;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.Footer-module__text___Ld5KS {
  font: var(--font-main);
  color: var(--color-disabled-text);
  -webkit-text-decoration: none;
  text-decoration: none;
}

.Footer-module__casket___qXGoK {
  width: 1238px;
  display: grid;
  padding-left: 134px;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
}

.Footer-module__case___HJlaJ {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.Footer-module__caption___ck9cv {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
}

.Footer-module__organ___n93jX {
  display: flex;
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
}

.Footer-module__version___DNr3J {
  display: flex;
  align-items: baseline;
  font-family: Inter;
  font-size: 17px;
  font-weight: 500;
  gap: 5px;
}

.Footer-module__facts___NNUQ0 {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
}

@media (min-width: 768px) and (max-width: 1199px) {

  .Footer-module__content___BgcQK {
    width: 692px;
  }

  .Footer-module__linksBox___sLm2l {
    gap: 10px;
  }

  .Footer-module__links___CApOz {
    gap: 8px;
  }

  .Footer-module__author___Bzdox {
    align-self: stretch;
    width: 692px;
  }

  .Footer-module__text___Ld5KS {
    font-size: 12px;
  }

  .Footer-module__casket___qXGoK {
    width: 692px;
    padding-left: 0px;
    gap: 161px;
  }

  .Footer-module__case___HJlaJ {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .Footer-module__caption___ck9cv {
    font-size: 14px;
  }

  .Footer-module__organ___n93jX {
    font-size: 12px;
  }

  .Footer-module__version___DNr3J {
    font-size: 14px;
    align-items: baseline;
  }

  .Footer-module__facts___NNUQ0 {
    font-size: 12px;
  }

}

@media (min-width: 360px) and (max-width: 767px) {

  .Footer-module__wrapper___KqdVZ {
    width: 324px;
    gap: 47px;
  }

  .Footer-module__content___BgcQK {
    flex-direction: column;
    width: 324px;
    gap: 25px;
  }

  .Footer-module__linksBox___sLm2l {
    gap: 10px;
  }

  .Footer-module__image___LY_3u {
    width: 76px;
    height: 76px;
  }

  .Footer-module__links___CApOz {
    gap: 8px;
  }

  .Footer-module__author___Bzdox {
    display: flex;
    justify-content: center;
    align-self: stretch;
    width: 324px;
  }

  .Footer-module__casket___qXGoK {
    display: flex;
    flex-direction: column;
    width: 324px;
    gap: 40px;
    padding-left: 0px;

  }

  .Footer-module__case___HJlaJ {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .Footer-module__caption___ck9cv {
    font-size: 14px;
  }

  .Footer-module__organ___n93jX {
    font-size: 12px;
  }

  .Footer-module__version___DNr3J {
    font-size: 14px;
    align-items: baseline;
  }

  .Footer-module__facts___NNUQ0 {
    font-size: 12px;
  }

}`, "",{"version":3,"sources":["webpack://./src/widgets/footer/ui/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,6BAAqB;EAArB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAS;IACT,iBAAiB;;EAEnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 98px;\n}\n\n.content {\n  display: flex;\n  width: 1238px;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.linksBox {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n}\n\n.image {\n  width: 104px;\n  height: 104px;\n}\n\n.image img {\n  width: 100%;\n}\n\n.links {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n}\n\n.author {\n  display: flex;\n  width: 1238px;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 10px;\n}\n\n.text {\n  font: var(--font-main);\n  color: var(--color-disabled-text);\n  text-decoration: none;\n}\n\n.casket {\n  width: 1238px;\n  display: grid;\n  padding-left: 134px;\n  grid-template-columns: 1fr 1fr;\n  justify-content: space-between;\n}\n\n.case {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.caption {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.organ {\n  display: flex;\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n.version {\n  display: flex;\n  align-items: baseline;\n  font-family: Inter;\n  font-size: 17px;\n  font-weight: 500;\n  gap: 5px;\n}\n\n.facts {\n  font-family: Inter;\n  font-size: 16px;\n  font-weight: 400;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n\n  .content {\n    width: 692px;\n  }\n\n  .linksBox {\n    gap: 10px;\n  }\n\n  .links {\n    gap: 8px;\n  }\n\n  .author {\n    align-self: stretch;\n    width: 692px;\n  }\n\n  .text {\n    font-size: 12px;\n  }\n\n  .casket {\n    width: 692px;\n    padding-left: 0px;\n    gap: 161px;\n  }\n\n  .case {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .caption {\n    font-size: 14px;\n  }\n\n  .organ {\n    font-size: 12px;\n  }\n\n  .version {\n    font-size: 14px;\n    align-items: baseline;\n  }\n\n  .facts {\n    font-size: 12px;\n  }\n\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n\n  .wrapper {\n    width: 324px;\n    gap: 47px;\n  }\n\n  .content {\n    flex-direction: column;\n    width: 324px;\n    gap: 25px;\n  }\n\n  .linksBox {\n    gap: 10px;\n  }\n\n  .image {\n    width: 76px;\n    height: 76px;\n  }\n\n  .links {\n    gap: 8px;\n  }\n\n  .author {\n    display: flex;\n    justify-content: center;\n    align-self: stretch;\n    width: 324px;\n  }\n\n  .casket {\n    display: flex;\n    flex-direction: column;\n    width: 324px;\n    gap: 40px;\n    padding-left: 0px;\n\n  }\n\n  .case {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .caption {\n    font-size: 14px;\n  }\n\n  .organ {\n    font-size: 12px;\n  }\n\n  .version {\n    font-size: 14px;\n    align-items: baseline;\n  }\n\n  .facts {\n    font-size: 12px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Footer-module__wrapper___KqdVZ`,
	"content": `Footer-module__content___BgcQK`,
	"linksBox": `Footer-module__linksBox___sLm2l`,
	"image": `Footer-module__image___LY_3u`,
	"links": `Footer-module__links___CApOz`,
	"icon": `Footer-module__icon___T6Dcd`,
	"author": `Footer-module__author___Bzdox`,
	"text": `Footer-module__text___Ld5KS`,
	"casket": `Footer-module__casket___qXGoK`,
	"case": `Footer-module__case___HJlaJ`,
	"caption": `Footer-module__caption___ck9cv`,
	"organ": `Footer-module__organ___n93jX`,
	"version": `Footer-module__version___DNr3J`,
	"facts": `Footer-module__facts___NNUQ0`
};
export default ___CSS_LOADER_EXPORT___;
